// extracted by mini-css-extract-plugin
export default {"row":"CategoryRowRiskLevel_row__CsW3w","chips":"CategoryRowRiskLevel_chips__lTwfw"};